import { render, staticRenderFns } from "./CategoryDefault.vue?vue&type=template&id=080b0bf4&scoped=true&"
import script from "./CategoryDefault.vue?vue&type=script&lang=js&"
export * from "./CategoryDefault.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDefault.vue?vue&type=style&index=0&id=080b0bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b0bf4",
  null
  
)

export default component.exports